module.exports = __webpack_public_path__ + "media/images/lavita_banner/composed_banner/banner__sponsor__text__left--en-f84db1c7b5c29d1b24b8cb3f8b9a92ce.png";